require('lang');


// CSS
require("def.css");
require("new.css");
require("css/layout.css");
require("css/global.css");
require("ui.dynatree.css");
require("ui-lightness/jquery-ui-1.8.24.custom.css");
require("editor_rewrite.css");
require("opentip.css");
require("css/flexboxgrid.min.css");
require("css/flags.css");


require("OwlCarousel2/owl.carousel.min.css");
require("OwlCarousel2/owl.theme.default.min.css");


// JS
require('script-loader!js/jquery3.3.1.min');
require('script-loader!js/jquery-migrate-1.4.1');
require('script-loader!js/jquery_ui.js');
require('script-loader!js/jquery.dynatree.js');
require('script-loader!js/jquery_form.js');
require('script-loader!js/jquery.tokeninput.js');
require('script-loader!js/global.js');
require('script-loader!js/def.js');
require('script-loader!OwlCarousel2/owl.carousel.min.js');

require('script-loader!js/ua-parser.min.js');
require('script-loader!editors/ckeditor_4.4/ckeditor.js');
